import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfferPropositionWidgetComponent } from './offer-proposition-widget.component';


const routes: Routes = [
  {path: 'offer-proposition', children: [
    {path: 'widget/:personId', component: OfferPropositionWidgetComponent},
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class OfferPropositionWidgetRoutingModule { }
